<template>
  <div class="container">
    <div class="background-image"></div>
    <div class="text-container">
      <h1 class="main-title">让装修轻松省钱</h1>
      <h2 class="sub-title">买建材、选设计、挑工人一站式服务</h2>
    </div>
    <div class="monkey-image">
      <img alt="装饰图案" src="houzi.png"/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NewsView',
  data() {
    return {
      newsList: [],
      isLoading: true,
      error: null,
      startX: null,
      startY: null,
    };
  },
  mounted() {
    // 添加触摸事件监听
    document.addEventListener('touchstart', this.handleTouchStart, { passive: false });
    document.addEventListener('touchend', this.handleTouchEnd, { passive: false });
    // 添加滚轮事件监听
    window.addEventListener('wheel', this.handleWheelScroll);
    // 禁用快捷键缩放
    document.addEventListener('keydown', this.handleKeyDown);
    // 禁用双指缩放（移动端）
    document.addEventListener('wheel', this.handleWheel, {passive: false});
    // 禁用触摸事件缩放
    document.addEventListener('touchmove', this.handleTouchMove, {passive: false});
  },
  beforeUnmount() {
    // 移除触摸事件监听
    document.removeEventListener('touchstart', this.handleTouchStart);
    document.removeEventListener('touchend', this.handleTouchEnd);
    window.removeEventListener('wheel', this.handleWheelScroll);

    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('wheel', this.handleWheel);
    document.removeEventListener('touchmove', this.handleTouchMove);
  },
  computed: {
  },
  methods: {
    // 新增触摸事件处理
    handleTouchStart(e) {
      this.startY = e.touches[0].clientY;
    },
    handleTouchEnd(e) {

      const endY = e.changedTouches[0].clientY;
      const deltaY = endY - this.startY;
      const deltaX = Math.abs(e.changedTouches[0].clientX - this.startX);
      console.log('1',deltaY,deltaX,Math.abs(deltaY))

      // 垂直滑动距离大于30px且水平滑动小于50px时才触发
      if (Math.abs(deltaY) > 50 && deltaX < 400) {

        if (deltaY > 0) { // 向下滑动

        } else if (deltaY < 0) { // 向上滑动
          this.$router.push('/project-list.html'); // 跳转
        }
      }
      this.startY = null;
    },
    handleWheelScroll(e) {
      if (e.ctrlKey || e.metaKey) return; // 过滤组合键操作
      if (e.deltaY > 0) { // 检测向下滚动
        this.$router.push('/project-list.html');
      }
    },
    handleKeyDown(e) {
      // 阻止Ctrl+加号/减号/鼠标滚轮
      if ((e.ctrlKey === true || e.metaKey) &&
          (e.keyCode === 61 || e.keyCode === 107 ||
              e.keyCode === 173 || e.keyCode === 109 ||
              e.keyCode === 187 || e.keyCode === 189)) {
        e.preventDefault();
      }
    },
    handleWheel(e) {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
      }
    },
    handleTouchMove(e) {
      if (e.scale !== 1) {
        e.preventDefault();
      }
    }
  },
};
</script>

<style>
@media (max-width: 768px) {
  .text-container {
    left: 70% !important;
    top: 55% !important;
    transform: translate(-50%, -50%);
    white-space: normal;
  }

  .main-title {
    font-size: 9vw;
  }

  .sub-title {
    font-size: 4.5vw;
  }

  .monkey-image {
    left: 20% !important;
    bottom: 35% !important;
    transform: translateX(-50%);
    width: 60vmin;
  }
  .background-image {
    z-index: 0 !important;
  }
}
.background-image {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-image: url('../../public/shouyebj.webp');
  background-size: cover;
  background-position: center;
  z-index: -1;
}
.main-title {
  font-size: 6vw;
  font-weight: 700;
  color: white;
  line-height: 1.2;
}

.sub-title {
  font-size: 3vw;
  font-weight: 500;
  color: white;
  margin-top: 1rem;
}

.monkey-image {
  position: fixed;
  bottom: 25%;
  left: 15%;
  width: 40vmin;
  height: auto;
}

.monkey-image img {
  width: 100%;
  height: auto;
  max-width: 500px;
  max-height: 600px;
}

.text-container {
  position: fixed;
  top: 55%;
  left: 65%;
  transform: translate(-50%, -50%);
  text-align: center;
  white-space: nowrap;
}


</style>